module.exports = __webpack_public_path__ + "img/doc-crop-after.d0648c0e.png";